import { canv } from "@/canv/global";
import { escapeString, getTarget, MakeRequest, setClick } from "@/canv/utils.js";

export class RenameWindow {
    async open() {
        this.boardUID = canv.getInitDataProp("boardUID");

        const renameWindowWrapper = document.createElement("div");
        renameWindowWrapper.classList.add("renameWindowWrapper");
        document.body.prepend(renameWindowWrapper);

        renameWindowWrapper.innerHTML += this.getMenu(canv.getInitDataProp("boardName"));

        this.init();
    }

    init() {
        setClick("renameWindowWrapper", this.wrapperClick.bind(this));

        setClick("renameWindowActionsItemAction", this.clickAction.bind(this));
        setClick("renameWindowActionsItemBack", this.clickBack.bind(this));

        // search input change
        const inputField = document.getElementsByClassName("renameWindowNameWrapperField")[0];
        if (inputField !== undefined) {
            inputField.addEventListener("focus", this.inputState.bind(this, 1), false);
            inputField.addEventListener("blur", this.inputState.bind(this, 2), false);
        }
    }

    inputState(state) {
        canv.appInterface.inputFocused = state;
    }

    close() {
        const markWrapper = document.getElementsByClassName("renameWindowWrapper")[0];
        if (markWrapper !== undefined) {
            markWrapper.outerHTML = "";
        }
    }

    /* Templates */

    getMenu(boardName) {
        const template = `
            <div class="renameWindow">
                <div class="renameWindowAbout">Название доски</div>
                <div class="renameWindowName">
                    <div class="renameWindowNameWrapper">
                        <input type="text" class="renameWindowNameWrapperField" placeholder="Ваша доска" value="${boardName}">
                    </div>
                </div>
                <div class="renameWindowDescription">Выбирайте короткие и запоминающиеся названия.<br> Так будет проще найти нужную доску.</div>
                <div class="renameWindowActions">
                    <div class="renameWindowActionsItem renameWindowActionsItemAction">Готово</div>
                    <div class="renameWindowActionsItem renameWindowActionsItemBack">Отмена</div>
                </div>
            </div>
        `;

        return template;
    }

    /* Proccessors */

    wrapperClick(e) {
        const tryInner = getTarget(e, "renameWindow");
        if (tryInner == null) {
            this.close();
        }
    }

    async clickAction() {
        const name = document.getElementsByClassName(
            "renameWindowNameWrapperField",
        )[0] as HTMLInputElement;

        try {
            const value = name?.value?.slice(0, 250) || "";
            if (!value || value === "") {
                this.close();
                return;
            }
            await MakeRequest(
                "/api/v2/board/name/set",
                {
                    boardUID: this.boardUID,
                    name: value,
                    token: canv.getInitDataProp("userToken"),
                },
                true,
            );

            document.title = value;

            canv.setInitDataProp("boardName", escapeString(value));
            canv.appInterface.infoWindow.open("Сохранено");
        } catch {}

        this.close();
    }

    clickBack() {
        this.close();
    }

    boardUID = "";
}
